import { Button, ButtonSize, ButtonVariant } from '@hourly-hds/components';
import { User } from '@hourly-hds/icons/colored';
import StepLayout from '../_shared/StepLayout';
import { SalesRepresentative } from '../data/models/salesRepresentative.model';
import styles from './Greetings.module.css';

interface GreetingsProps {
  salesRepresentative: SalesRepresentative;
  onContinue?: () => void;
  disabled?: boolean;
}

const Greetings = ({ salesRepresentative, disabled = false, onContinue }: GreetingsProps) => {
  return (
    <StepLayout>
      <div className={styles.container}>
        <div className={styles.content}>
          <User className={styles.avatar} />

          <div className={styles.greetings}>
            <StepLayout.Title>
              Hi, this is {salesRepresentative.name}, your sales representative!
            </StepLayout.Title>
            <StepLayout.Description>{"Let's activate your partner portal"}</StepLayout.Description>
          </div>
          <StepLayout.Actions>
            <Button
              fullWidth
              disabled={disabled}
              label="Start Now"
              variant={ButtonVariant.Primary}
              size={ButtonSize.Large}
              onClick={() => onContinue?.()}
            />
          </StepLayout.Actions>
        </div>
        <div className={styles.contact}>
          <span>Have Questions?</span>
          <span>
            Email: <a href={`mailto:${salesRepresentative.email}`}>{salesRepresentative.email}</a>
          </span>
          <span>
            Call:
            <a href={`tel:${salesRepresentative.phoneNumber}`}>
              {salesRepresentative.phoneNumberFormatted}
            </a>
          </span>
        </div>
      </div>
    </StepLayout>
  );
};

export default Greetings;
